import { PopoutWidget } from '../workspace/widgets/WidgetInterface';
import { ToolDefinition } from './ToolDefinition';

export interface ToolboxItem {
    id: string;
    label?: string;
    icon?: string;
    ui?: (() => JSX.Element) | React.ComponentType<{ widget: PopoutWidget }>;
    keepOpen?: boolean;
    placement?: string;
    skipEquip?: boolean;
    tools: ToolDefinition[];
    shortcut?: string;
    weight?: number;
}

export const ToolboxItem = (item: ToolboxItem) => item;
